import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QuoterVehicleUsePaged } from '../../../models/quotation-model/catalogs/quoterConfig/quoter-vehicle-use.model';
import { VehicleUse } from '../../../models/quotation-model/catalogs/vehicle-use.model.model';
import { CommonFilterRequest } from '../../../models/quotation-model/customer.model';
import { QuotationCompareCoverages } from '../../../models/quotation-model/main/quotation-compare-coverages.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VehicleUseService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  createCoveragesUrl(ids: QuotationCompareCoverages[]): string {
    var queryString = '';
    ids.forEach((id: any) => {
      queryString = queryString + Object.keys(id).map((key) => key + '=' + id[key]) + '&';
    });
    const editQueryString = queryString.slice(0, -1);
    return editQueryString;
  }

  getVehicles(brandId: number, coverageId: number): Observable<VehicleUse[]> {
    return this.http.get<VehicleUse[]>(
      this.URL_API + '/VehicleUse?brandId=' + brandId + '&coverageIds=' + coverageId,
    );
  }

  getVehiclesToCoverage(coverageId: number): Observable<VehicleUse[]> {
    return this.http.get<VehicleUse[]>(
      this.URL_API + '/VehicleUse/GetVehicleUsesToCoverage?coverageId=' + coverageId,
    );
  }

  getPagedVehicleUses(filters: CommonFilterRequest): Observable<QuoterVehicleUsePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '');
    return this.http.get<QuoterVehicleUsePaged>(this.URL_API + '/VehicleUse/GetPagedVehicleUses', {
      params,
    });
  }
}
